<template>
<div>
    <!-- modal -->
    <b-modal id="accountingTransactionTypeFormModal" centered size="lg" no-close-on-backdrop ref="accountingTransactionTypeFormModal" :title=" $t('accountingTransactionType.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()">
        <b-form @submit.prevent="addOrUpdate()">
            <b-button type="submit" style="display: none;"></b-button>
            <validation-observer ref="simpleRules">
                <b-row>
                    <b-col class="col-lg-6">
                        <label for="accounting-transaction-type-name-input">{{ $t('accountingTransactionType.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('accountingTransactionType.name')" rules="required">
                                <b-form-input id="accounting-transaction-type-name-input" v-model="name" size="sm" maxlength="50" :disabled=newRecordCheck :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col class="col-lg-6">
                        <label for="accounting-transaction-type-code-input">{{ $t('accountingTransactionType.code') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('accountingTransactionType.code')" rules="required">
                                <b-form-input id="accounting-transaction-type-code-input" v-model="code" size="sm" maxlength="2" :disabled=newRecordCheck :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-form>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getAccountingTransactionTypeList: {
            name: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            code: '',
            newRecordCheck : false,
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['accountingTransactionTypeFormModal'].show()
            this.id = id
            if(id > 0){
                this.newRecordCheck = true
            }
            else{
                this.newRecordCheck = false 
            }
            const data = {
                id: this.id
            }
            const controller = {
                name: 'AccountingTransactionType'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.name = response.data.accountingTransactionType.name
                    this.code = response.data.accountingTransactionType.code
                } else {
                    this.$bvModal.hide('accountingTransactionTypeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                code: this.code
            }
            const controller = {
                name: 'AccountingTransactionType'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('accountingTransactionTypeFormModal')
                            this.getAccountingTransactionTypeList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
